import BaseController from "./base_controller"

export default class extends BaseController {
  static values = {
    message: String,
    type: String,
    duration: { type: Number, default: 3000 }
  }

  notify() {
    this.dispatchNotify(this.messageValue, { duration: this.durationValue, type: this.typeValue })
  }
}
